/* Rubbellos-Pop-up (23.09.2026) — siehe sections/ohmy-rubbel-popup.liquid.
   Ablauf: Rubbeln → „Was interessiert dich am meisten?“ → E-Mail → Code.
   Auslöser nach E-Commerce-Praxis: erst nach Scrolltiefe UND Mindestverweildauer,
   am Desktop zusätzlich bei Exit-Intent. Einmal pro Sitzung, nach Schließen
   Pause (Tage aus der Einstellung), nach Anmeldung nie wieder. */
(() => {
  const root = document.getElementById('OmRubbel');
  if (!root) return;

  const cfg = {
    scroll: +root.dataset.scroll || 40,
    delay: (+root.dataset.delay || 0) * 1000,
    cooldown: (+root.dataset.cooldown || 7) * 864e5,
    exit: root.dataset.exit === 'true',
    code: root.dataset.code || '',
    editor: root.dataset.editor === 'true',
    tags: root.dataset.tags || 'newsletter,rubbellos'
  };
  const KEY = 'ohmy-rubbel';
  const $ = (s) => root.querySelector(s);
  const tab = document.getElementById('OmRubbelTab');

  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    set(v) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(store.get(), v))); } catch (e) {} }
  };
  const session = {
    get() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } },
    set() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  };

  let step = 'scratch';
  let goal = null;
  let lastFocus = null;

  /* ---------- Öffnen / Schließen ---------- */
  function open() {
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    session.set();
    hideTab();
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      if (step === 'scratch') paintCover();
      const f = root.querySelector('.om-rl__step:not([hidden]) [data-autofocus]') || $('.om-rl__close');
      f && f.focus({ preventScroll: true });
    });
    document.addEventListener('keydown', onKey);
  }
  function close(reason) {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    setTimeout(() => { root.hidden = true; }, 300);
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
    if (reason === 'done') return;
    store.set({ closedAt: Date.now() });
    if (step !== 'done') showTab();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...root.querySelectorAll('button,a[href],input')].filter((el) => el.offsetParent);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  root.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => close()));

  /* ---------- Erinnerungs-Lasche ---------- */
  function showTab() {
    if (!tab || store.get().tabOff) return;
    tab.hidden = false;
    requestAnimationFrame(() => tab.classList.remove('is-away'));
  }
  function hideTab() { if (tab) { tab.classList.add('is-away'); } }
  if (tab) {
    tab.addEventListener('click', (e) => {
      if (e.target.closest('[data-tab-off]')) { e.stopPropagation(); store.set({ tabOff: true }); hideTab(); return; }
      open();
    });
  }

  /* ---------- Schritte ---------- */
  function go(name) {
    step = name;
    root.querySelectorAll('.om-rl__step').forEach((s) => { s.hidden = s.dataset.step !== name; });
    const f = root.querySelector(`[data-step="${name}"] [data-autofocus]`);
    f && setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  root.querySelectorAll('[data-go]').forEach((b) => b.addEventListener('click', () => go(b.dataset.go)));

  /* ---------- Schritt 1: Rubbelfeld ---------- */
  const canvas = $('.om-rl__canvas');
  const ctx = canvas.getContext('2d');
  let painted = false, revealed = false, drawing = false, last = null, checkT = 0;

  // Goldfolie: Palette-Gold #D9B65B, Licht/Schatten nur als Mischung mit Weiß bzw. Slate
  const GOLD = root.dataset.gold || '#D9B65B';
  const hex = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
  const mix = (a, b, t) => { const x = hex(a), y = hex(b); return `rgb(${x.map((v, i) => Math.round(v + (y[i] - v) * t)).join(',')})`; };

  function paintCover() {
    if (painted || revealed) return;
    const r = canvas.getBoundingClientRect();
    if (!r.width) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = r.width * dpr; canvas.height = r.height * dpr;
    ctx.scale(dpr, dpr);
    const w = r.width, h = r.height;
    const slate = getComputedStyle(root).getPropertyValue('--rl-text').trim() || '#2F3E4E';

    // 1 · Metallverlauf: hell – Gold – dunkel – Gold – hell
    const g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, mix(GOLD, '#FFFFFF', .45));
    g.addColorStop(.28, GOLD);
    g.addColorStop(.5, mix(GOLD, slate, .22));
    g.addColorStop(.72, GOLD);
    g.addColorStop(1, mix(GOLD, '#FFFFFF', .38));
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    // 2 · gebürstete Folie: feine Querstriche
    for (let i = 0; i < h * 1.4; i++) {
      const y = Math.random() * h;
      ctx.strokeStyle = Math.random() < .5 ? 'rgba(255,255,255,.10)' : 'rgba(47,62,78,.06)';
      ctx.lineWidth = Math.random() * .8 + .3;
      ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y + (Math.random() - .5) * 4); ctx.stroke();
    }
    // 3 · Glitzer
    for (let i = 0; i < w * .6; i++) {
      ctx.fillStyle = `rgba(255,255,255,${Math.random() * .7 + .2})`;
      const s = Math.random() * 1.4 + .4;
      ctx.fillRect(Math.random() * w, Math.random() * h, s, s);
    }
    // 4 · Los-Rand: gepunktete Perforation innen
    ctx.setLineDash([2, 5]); ctx.lineCap = 'round';
    ctx.strokeStyle = 'rgba(47,62,78,.35)'; ctx.lineWidth = 1.5;
    ctx.strokeRect(10, 10, w - 20, h - 20);
    ctx.setLineDash([]);
    // 5 · Sterne als Line-Icons, geprägt (hell versetzt, dann Slate)
    const star = (cx, cy, s) => {
      ctx.beginPath();
      ctx.moveTo(cx, cy - s);
      ctx.quadraticCurveTo(cx + s * .15, cy - s * .15, cx + s, cy);
      ctx.quadraticCurveTo(cx + s * .15, cy + s * .15, cx, cy + s);
      ctx.quadraticCurveTo(cx - s * .15, cy + s * .15, cx - s, cy);
      ctx.quadraticCurveTo(cx - s * .15, cy - s * .15, cx, cy - s);
      ctx.stroke();
    };
    const stars = [[.14, .28, 10], [.86, .7, 12], [.8, .24, 7], [.2, .74, 6]];
    ctx.lineJoin = 'round'; ctx.lineWidth = 1.6;
    ctx.strokeStyle = 'rgba(255,255,255,.55)';
    stars.forEach(([x, y, s]) => star(w * x + 1, h * y + 1, s));
    ctx.strokeStyle = 'rgba(47,62,78,.55)';
    stars.forEach(([x, y, s]) => star(w * x, h * y, s));
    // 6 · Schrift geprägt
    const font = getComputedStyle(root).fontFamily;
    const emboss = (txt, y, size, weight, alpha) => {
      ctx.font = `${weight} ${size}px ${font}`;
      ctx.fillStyle = 'rgba(255,255,255,.55)'; ctx.fillText(txt, w / 2 + 1, y + 1);
      ctx.fillStyle = `rgba(47,62,78,${alpha})`; ctx.fillText(txt, w / 2, y);
    };
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    emboss(root.dataset.coverLabel || 'Hier rubbeln', h / 2 - 8, Math.round(w / 12), 600, 1);
    emboss(root.dataset.coverSub || 'mit Finger oder Maus', h / 2 + w / 15, Math.round(w / 24), 500, .75);
    painted = true;
  }

  // Goldflocken, die beim Rubbeln abfallen
  const fxBox = $('.om-rl__fx');
  let flakeT = 0;
  function flakes(p) {
    const now = Date.now();
    if (now - flakeT < 35 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    flakeT = now;
    const cr = canvas.getBoundingClientRect(), br = fxBox.getBoundingClientRect();
    for (let i = 0; i < 3; i++) {
      const f = document.createElement('i');
      f.className = 'om-rl__flake';
      const s = Math.random() * 4 + 3;
      f.style.width = s + 'px'; f.style.height = s * (Math.random() * .6 + .5) + 'px';
      f.style.left = cr.left - br.left + p.x + 'px'; f.style.top = cr.top - br.top + p.y + 'px';
      f.style.background = Math.random() < .5 ? GOLD : mix(GOLD, '#FFFFFF', .4);
      f.style.setProperty('--dx', (Math.random() - .5) * 60 + 'px');
      f.style.setProperty('--dy', 40 + Math.random() * 60 + 'px');
      f.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
      fxBox.appendChild(f);
      setTimeout(() => f.remove(), 800);
    }
  }

  function pos(e) {
    const r = canvas.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top, w: r.width };
  }
  function scratch(p) {
    const size = Math.max(22, p.w / 11);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineWidth = size * 2; ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(last ? last.x : p.x, last ? last.y : p.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    ctx.globalCompositeOperation = 'source-over';
    last = p;
    flakes(p);
    root.classList.add('is-scratching');
    const now = Date.now();
    if (now - checkT > 120) { checkT = now; if (cleared() > .45) reveal(); }
  }
  function cleared() {
    const { width: w, height: h } = canvas;
    const d = ctx.getImageData(0, 0, w, h).data;
    let n = 0, t = 0;
    for (let i = 3; i < d.length; i += 4 * 16) { t++; if (d[i] < 20) n++; }
    return n / t;
  }
  canvas.addEventListener('pointerdown', (e) => {
    if (revealed) return;
    drawing = true; last = null;
    canvas.setPointerCapture(e.pointerId);
    scratch(pos(e));
  });
  canvas.addEventListener('pointermove', (e) => { if (drawing) scratch(pos(e)); });
  ['pointerup', 'pointercancel'].forEach((t) => canvas.addEventListener(t, () => { drawing = false; last = null; }));
  $('.om-rl__reveal').addEventListener('click', () => reveal());

  function reveal() {
    if (revealed) return;
    revealed = true;
    root.classList.add('is-revealed');
    store.set({ revealed: true });
    confetti();
    const b = $('.om-rl__win [data-autofocus]');
    b && setTimeout(() => b.focus({ preventScroll: true }), 400);
  }

  function confetti() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const fx = $('.om-rl__fx');
    const cr = canvas.getBoundingClientRect(), br = fx.getBoundingClientRect();
    const cx = cr.left - br.left + cr.width / 2, cy = cr.top - br.top + cr.height / 2;
    const colors = (root.dataset.confetti || '#D9B65B,#D9B65B,#8BCAE4,#55A89C,#CC598B,#5A54A0').split(',');
    fx.innerHTML = '';
    for (let i = 0; i < 34; i++) {
      const el = document.createElement('i');
      const a = Math.random() * Math.PI * 2, d = 90 + Math.random() * 150;
      el.style.left = cx + 'px'; el.style.top = cy + 'px';
      el.style.background = colors[i % colors.length];
      el.style.setProperty('--dx', Math.cos(a) * d + 'px');
      el.style.setProperty('--dy', Math.sin(a) * d + 60 + 'px');
      el.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
      el.style.animationDelay = Math.random() * 80 + 'ms';
      fx.appendChild(el);
    }
    setTimeout(() => { fx.innerHTML = ''; }, 1400);
  }

  /* ---------- Schritt 2: Zielfrage ---------- */
  root.querySelectorAll('.om-rl__goal').forEach((b) => b.addEventListener('click', () => {
    root.querySelectorAll('.om-rl__goal').forEach((x) => x.classList.toggle('is-picked', x === b));
    goal = { title: b.dataset.title, tag: b.dataset.tag, link: b.dataset.link };
    store.set({ goal });
    root.querySelectorAll('[data-goal-name]').forEach((el) => { el.textContent = goal.title; });
    setTimeout(() => go('email'), 220);
  }));

  /* ---------- Schritt 3: E-Mail ---------- */
  const form = $('.om-rl__form');
  const input = $('.om-rl__input');
  const err = $('.om-rl__err');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      input.setAttribute('aria-invalid', 'true'); err.hidden = false; input.focus(); return;
    }
    input.removeAttribute('aria-invalid'); err.hidden = true;
    const btn = form.querySelector('button[type=submit]');
    btn.disabled = true;
    const tags = [cfg.tags, goal && goal.tag ? 'ziel-' + goal.tag : ''].filter(Boolean).join(',');
    form.querySelector('[name="contact[tags]"]').value = tags;
    let ok = true;
    if (!cfg.editor && form.action && !/^(file:|about:)/.test(form.action)) {
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        // Shopify leitet bei Bot-Verdacht auf /challenge — dann regulär absenden (Seite lädt neu, Code kommt per Mail).
        if (res.redirected && /challenge/.test(res.url)) { store.set({ done: true }); form.submit(); return; }
        ok = res.ok;
      } catch (x) { ok = false; }
    }
    btn.disabled = false;
    if (!ok) { err.textContent = root.dataset.errNet || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'; err.hidden = false; return; }
    store.set({ done: true });
    finish();
  });

  /* ---------- Schritt 4: Code ---------- */
  function finish() {
    const cta = $('[data-cta]');
    const target = (goal && goal.link) || cta.dataset.fallback || '/collections/all';
    cta.href = cfg.code ? `/discount/${encodeURIComponent(cfg.code)}?redirect=${encodeURIComponent(target)}` : target;
    if (tab) tab.hidden = true;
    go('done');
  }
  const copy = $('.om-rl__copy');
  copy && copy.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(cfg.code); } catch (e) {
      const t = document.createElement('textarea'); t.value = cfg.code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (x) {} t.remove();
    }
    copy.classList.add('is-done');
    copy.querySelector('span').textContent = copy.dataset.done || 'Kopiert';
  });
  $('[data-cta]').addEventListener('click', () => close('done'));
  root.querySelectorAll('[data-finish-close]').forEach((b) => b.addEventListener('click', () => close('done')));

  /* ---------- Auslöser ---------- */
  window.OhMyRubbel = { open, close, reset() { try { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {} } };

  if (cfg.editor) {
    // Theme-Editor: öffnen, sobald die Section ausgewählt wird
    document.addEventListener('shopify:section:select', (e) => { if (e.detail.sectionId === root.dataset.sectionId) open(); });
    document.addEventListener('shopify:section:deselect', (e) => { if (e.detail.sectionId === root.dataset.sectionId) close('done'); });
    return;
  }

  const s = store.get();
  if (s.done) return;
  if (s.closedAt && Date.now() - s.closedAt < cfg.cooldown) {
    // Pause nach Schließen: nur die Lasche, kein automatisches Aufgehen
    if (s.revealed || s.closedAt) showTab();
    return;
  }
  if (session.get()) { showTab(); return; }

  const t0 = Date.now();
  let armed = false, waiting = false;
  function depth() {
    const h = document.documentElement.scrollHeight - innerHeight;
    return h > 0 ? (scrollY / h) * 100 : 100;
  }
  function consentPending() {
    const b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    const r = b.getBoundingClientRect(), c = getComputedStyle(b);
    return r.height > 0 && c.display !== 'none' && c.visibility !== 'hidden' && +c.opacity > 0;
  }
  // Nur wirklich offene Dialoge zählen: das Theme hat Menü, Warenkorb und Suche immer mit
  // aria-modal im DOM und versteckt sie nur per CSS — die dürfen das Pop-up nicht sperren.
  function otherModalOpen() {
    return [...document.querySelectorAll('.om-rl-block, [aria-modal="true"]:not(#OmRubbel), [role="dialog"][open]')].some((el) => {
      if (el.closest('#OmRubbel')) return false;
      const r = el.getBoundingClientRect();
      if (r.width < 40 || r.height < 40 || r.bottom <= 0 || r.top >= innerHeight || r.right <= 0 || r.left >= innerWidth) return false;
      if (el.checkVisibility && !el.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
      const x = Math.min(Math.max(r.left + r.width / 2, 0), innerWidth - 1), y = Math.min(Math.max(r.top + r.height / 2, 0), innerHeight - 1);
      const hit = document.elementFromPoint(x, y);
      return !!hit && el.contains(hit);
    });
  }
  function retry(force) {
    if (waiting) return;
    waiting = true;
    setTimeout(() => { waiting = false; tryOpen(force); }, 1500);
  }
  function tryOpen(force) {
    if (armed || !root.hidden) return;
    if (!force && (depth() < cfg.scroll || Date.now() - t0 < cfg.delay)) return;
    if (otherModalOpen()) { retry(force); return; }
    // erst nach der Cookie-Entscheidung: Shopifys Banner liegt sonst über dem Pop-up
    if (consentPending()) { retry(force); return; }
    armed = true;
    removeEventListener('scroll', onScroll);
    open();
  }
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; tryOpen(false); });
  }
  addEventListener('scroll', onScroll, { passive: true });
  // wer schnell scrollt und dann stehen bleibt, bekommt es nach Ablauf der Mindestzeit
  if (cfg.delay) setTimeout(() => tryOpen(false), cfg.delay + 50);
  if (cfg.exit && matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.addEventListener('mouseout', (e) => {
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 5000) tryOpen(true);
    });
  }
})();
